import React, { useState, useCallback, useEffect } from 'react'
import Switch2 from '../../Switch/Switch'
import modelModule from './ModelsComponent.module.scss'
import { _gpt_model } from '../../../localConstant'
import { collection, getDocs, updateDoc, addDoc, deleteDoc } from 'firebase/firestore'
import { db } from '../../../firebase'

function ModelsComponent() {
  const [models, setModels] = useState([])
  const modelsCollectionRef = collection(db, '/models')

  useEffect(() => {
    ;(async () => {
      const modelsSnapshot = await getDocs(modelsCollectionRef)
      const modelsDocs = modelsSnapshot.docs.map((doc) => {
        return { ...doc.data(), ref: doc.ref }
      })

      const gptModelValues = new Set(_gpt_model.map((gptModel) => gptModel.value))

      // firebaseから取得したmodelのうち_gpt_modelに存在するモデルのみ残す
      const filteredModels = modelsDocs
        .filter((model) => gptModelValues.has(model.value))
        .map((model) => {
          const matchingModel = _gpt_model.find((gptModel) => gptModel.value === model.value)
          return {
            ...model,
            displayName: matchingModel.displayName, // _gpt_modelからdisplayNameをattachする
            customDisplayName: model.customDisplayName || matchingModel.displayName // customDisplayNameが空だったら、displayNameをsetする
          }
        })

      // 足りないモデルを_gpt_modelから見つけ出し、missingModelsとする
      const missingModels = _gpt_model
        .filter((gptModel) => !filteredModels.some((model) => model.value === gptModel.value))
        .map((gptModel) => ({
          active: true,
          value: gptModel.value,
          displayName: gptModel.displayName,
          customDisplayName: gptModel.displayName
        }))

      let updatedModels = [...filteredModels, ...missingModels]
      updatedModels = updatedModels.sort((a, b) => {
        const indexA = _gpt_model.findIndex((gptModel) => gptModel.value === a.value)
        const indexB = _gpt_model.findIndex((gptModel) => gptModel.value === b.value)
        return indexA - indexB
      })
      console.log('Updated Models:', updatedModels)
      setModels(updatedModels)
    })()
  }, [])

  const saveModels = (model) => {
    const { displayName, ...modelWithoutDisplayName } = model
    if (model.hasOwnProperty('ref')) {
      updateDoc(model.ref, { ...modelWithoutDisplayName })
    } else {
      addDoc(modelsCollectionRef, { ...modelWithoutDisplayName })
    }
    alert('保存されました。')
  }

  const changeModelSetting = (updates, index) => {
    setModels((prev) => prev.map((item, i) => (i === index ? { ...item, ...updates } : item)))
  }

  return (
    <div className={modelModule.main}>
      <div className={modelModule['prompt-body-header']}>
        <div className={modelModule['sub-title-container']}>
          <h3 className={modelModule['sub-title']}>モデルの設定</h3>
        </div>
      </div>
      <div className={modelModule['prompt-body']}>
        <div className={modelModule['doc-list']}>
          <table className={modelModule['table']}>
            <thead>
              <tr>
                <th className={modelModule.active}>表示</th>
                <th className={modelModule.optionContent}>デフォルト名</th>
                <th className={modelModule.optionContent}>表示名</th>
                <th className={modelModule.active}>保存</th>
              </tr>
            </thead>
            <tbody>
              {models.map((model, index) => (
                <tr key={index} className={modelModule['tr-container']}>
                  <td className={modelModule.active}>
                    <Switch2
                      value={model.active}
                      checked={model.active}
                      onText={'表示'}
                      offText={'非表示'}
                      onChange={(e) => changeModelSetting({ active: !model.active }, index)}
                    />
                  </td>
                  <td>
                    <textarea value={model.displayName} disabled className={modelModule['option']} />
                  </td>
                  <td>
                    <textarea
                      value={model.customDisplayName}
                      className={modelModule['option']}
                      onChange={(e) => changeModelSetting({ customDisplayName: e.target.value }, index)}
                    />
                  </td>
                  <td className={modelModule.active}>
                    <button className={modelModule['save']} onClick={() => saveModels(model)}>
                      保存
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ModelsComponent
